import UseAssistant from "../UseAssistant";

const TestAssistantPage = () => {

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const uuid = params.get("uuid");
    const id = params.get("id");
    const markFlag=params.get("mark");
    return (
        <>
            <UseAssistant 
                uuid={uuid}
                assistantId={id}
                markFlag={markFlag}
            />
        </>
    )
}

export default TestAssistantPage